export default __webpack_public_path__ + "static/media/IconDesc_TurboFuel.256.cf974f32.png";